<h3>Create an Account</h3>

<form (ngSubmit)="onSubmit()" class="ui form"[formGroup]="authForm">
    <app-input inputType="text" label="Username" [control]="authForm.get('username')"></app-input>
    <app-input inputType="password" label="Password" [control]="authForm.get('password')"></app-input>
    <app-input inputType="password" label="Password Confirmation" [control]="authForm.get('passwordConfirmation')"></app-input>
    <div *ngIf="authForm.get('password').touched && 
                authForm.get('passwordConfirmation') &&
                authForm.errors" 
         class="ui red basic label">
        <p *ngIf="authForm.errors.passwordsDontMatch">
            Password and Password Confirmation must match
        </p>
        <p *ngIf="authForm.errors.noConnection">
            No internet connection detected. Failed to sign up.
        </p>
        <p *ngIf="authForm.errors.unknownError">
            Failed to sign up.
        </p>
    </div>
    <div>
        <button class="ui submit button primary">Submit</button>
    </div>
</form>
